import { FormGroup } from '@angular/forms';
import { orderBy } from 'lodash';

/* tslint:disable */

export function convertToEnglishLetter(str): string {
	for (let i = 0; i < str.length; i++) {
		str = str.replace(str[i], function (m) {
			switch (m) {
				case 'ş':
					return 's';
				case 'ı':
					return 'i';
				case 'ç':
					return 'c';
				case 'ü':
					return 'u';
				case 'ğ':
					return 'g';
				case 'ö':
					return 'o';
				case 'Ş':
					return 'S';
				case 'İ':
					return 'I';
				case 'Ç':
					return 'C';
				case 'Ğ':
					return 'G';
				case 'Ü':
					return 'U';
				case 'Ö':
					return 'O';
				case ' ':
					return '-';
				case m:
					return m;
			}
		});
	}
	return str;
}

//  export function cloneObject<T>(arg: T, type: { new(): T }): T {
//     let clonedObject = new type();
//     for (let prop in arg) {
//         clonedObject[prop] = arg[prop];
//     }
//     return clonedObject;
// }

export function getOrderType(order: number) {
	if (order === 1) {
		return 'DESC';
	} else {
		return 'ASC';
	}
}

export function convertFunction(str: string): any {
	try {
		return JSON.parse(str);
	} catch {
		return str;
	}
}

export function findIndex(value: string, findArg: string): number {
	let index: number;
	index = value.indexOf(findArg);
	return index;
}

/**
 * @param phoneNumber Phone Number
 */
export function removeMaskCharacters(phoneNumber: string): string {
	if (phoneNumber) {
		return phoneNumber.replace(/[\s\-\(\)]*/g, '');
	} else {
		return null;
	}
}

/**
 * Get the properties of object as a string array
 * like {prop1:'val1',prop2:'val2'...} => ['prop1','prop2'...]
 * @static
 * @param {*} [object={}] target object
 * @returns {string[]} result type
 * @memberof Util
 */
export function getObjectKeys(object: object = {}): string[] {
	return Object.keys(object);
}

/**
 * [1,2,3,4,2,3,4,4,4,] => [1,2,3,4]
 *
 * @static
 * @param {any[]} base array
 * @returns {any[]} array without duplicate value
 * @memberof Util
 */
export function uniq(arr: any[]): any[] {
	return Array.from(new Set(arr));
}

export function getFileExt(fileName: string): string {
	if (fileName && fileName.indexOf('.') !== -1) {
		const dotIndex: number = fileName.lastIndexOf('.');
		return fileName.substr(dotIndex + 1);
	} else {
	}
	return '';
}

export function getFileIcon(fileName: string): string {
	switch (getFileExt(fileName)) {
		case 'pdf':
			return 'fa fa-file-pdf-o';

		case 'zip':
		case 'rar':
		case '7-zip':
			return 'fa fa-file-archive-o';

		case 'docx':
		case 'doc':
			return 'fa a-file-word-o';

		case 'jpg':
		case 'png':
		case 'jpeg':
		case 'bmp':
			return 'fa fa-file-image-o';

		case 'txt':
			return 'fa fa-file-text-o';

		case 'pptx':
		case 'ppt':
			return 'fa fa-file-powerpoint-o';

		case 'xls':
		case 'xlsx':
			return 'fa fa-file-excel-o';

		default:
			return 'fa fa-file-o';
	}
}

export function getFormatedDate(date: Date): string {
	if (date instanceof Date) {
		const month = date.getMonth() + 1;
		const day = date.getDate();
		return `${day > 9 ? day : '0' + day}/${month > 9 ? month : '0' + month}/${date.getFullYear()}`;
	} else {
		const newDate = new Date(date);
		const month = newDate.getMonth() + 1;
		const day = newDate.getDate();

		return `${day > 9 ? day : '0' + day}/${month > 9 ? month : '0' + month}/${newDate.getFullYear()}`;
	}
}

export function convertToNumber(num: any): string {
	return String(num).replace(',', '.');
}

export function nullDateChecker(dateValue: number | Date | null): Date | null {
	if (dateValue === null) {
		return null;
	} else {
		return new Date(dateValue);
	}
}

export function setRatioValueLimit(form: FormGroup, valueControl: string, ratioControl: string) {
	form.get(valueControl).valueChanges.subscribe((value) => {
		if ((form.get(ratioControl).value === 'RATIO' || +form.get(ratioControl).value === 0) && value > 100) {
			form.get(valueControl).setValue(100);
		}
	});

	form.get(ratioControl).valueChanges.subscribe((value) => {
		if ((value === 'RATIO' || +value === 0) && (+form.get(valueControl).value || 0) > 100) {
			form.get(valueControl).setValue(100);
		}
	});
}

export function cumulativeSum(array: number[]) {
	array = array.map((element) => {
		if (typeof element === 'string' && !isNaN(element)) {
			element = Number(element);
		} else if (isNaN(element)) {
			element = 0;
		}
		return element;
	});
	return array.reduce((total, elem) => total + elem, 0);
}

export function areObjectsEqual(obj1: any, obj2: any): boolean {
	// İki nesne eşit uzunlukta değilse, birebir benzer olamazlar
	if (obj1 && obj2) {
		if (Object.keys(obj1).length !== Object.keys(obj2).length) {
			return false;
		}

		for (const key in obj1) {
			// obj1'deki her anahtar, obj2'de de bulunmalıdır
			if (!(key in obj2)) {
				return false;
			}

			const val1 = obj1[key];
			const val2 = obj2[key];

			// Eğer değerler nesne ise, rekürsif olarak karşılaştırma yapılır
			if (typeof val1 === 'object' && typeof val2 === 'object') {
				if (!areObjectsEqual(val1, val2)) {
					return false;
				}
			} else if (val1 !== val2) {
				// Değerler doğrudan karşılaştırılır
				return false;
			}
		}
	}
	// Tüm anahtarlar ve değerler eşleştiyse, nesneler birebir benzerdir
	return true;
}

// NOTE: multi-base-render'da data ile buradaki key bilgisini eşleştirmede sorun oluşuyordu. Timestamp tipi number iken bu methoddan sonra join() yüzünden string haline geliyordu.
export function groupDataByFields(data: unknown[], keys: string[]): Map<string, unknown[]> {
	const groups: Map<string, unknown[]> = new Map();
	data.forEach((item) => {
		const groupKey = keys.length > 1 ? keys.map((key) => item[key]).join(' - ') : item[keys[0]];
		if (!groups.has(groupKey)) {
			groups.set(groupKey, []);
		}
		groups.get(groupKey)?.push(item);
	});
	return groups;
}

export function findItemInData(data: unknown[], filterObject: object) {
	return data.find((obj) => Object.keys(filterObject).every((key) => obj[key] === filterObject[key]));
}

export function sortList(array: unknown[], sortBy: string, sortOrder: string = 'desc'): unknown[] {
	if (sortBy) {
		const sorter = (item: unknown) => (typeof item[sortBy] === 'string' ? item[sortBy].toLowerCase() : item[sortBy]);
		return orderBy(array, [sorter], [sortOrder]);
	}
	return array;
}

export function isObjectNotNull(value: unknown): boolean {
	return value !== undefined && value !== null;
}

export function convertJsonToCsv(data: unknown[]): string {
	if (!data || !data.length) {
		console.error('Veri boş!');
		return;
	}

	const separator = ',';
	const keys = Object.keys(data[0]);
	return (
		keys.join(separator) +
		'\n' +
		data
			.map((row) => {
				return keys
					.map((key) => {
						const escaped = ('' + row[key]).replace(/"/g, '""');
						return `"${escaped}"`;
					})
					.join(separator);
			})
			.join('\n')
	);
}
